var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PaginatedList',{attrs:{"queryName":"users","queryFields":"{\n      _id\n      email\n      profile {\n        name\n      }\n    }","searchBox":"","defaultIcon":"person","limit":20,"transformResult":_vm.transformResult}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }